import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ProfilePageRoutingModule } from './profile-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, ProfilePageRoutingModule]
})
export class ProfilePageModule {}
